module.exports = __webpack_public_path__ + "4f1a49ae20870212218257ff9606e2db.svg";